export const ALADDA_URL = "http://www.aladda.com/";